import type {
  CheckoutConfig,
  Duration,
  DurationTypes,
  PriceTypes,
} from './course';

export interface State {
  name: string;
  abbreviation: string;
}

export interface Hub {
  id: number;
  name: string;
}

export interface Period {
  type: PeriodTypes;
  label: PeriodTypesLabels;
}

export enum PeriodTypesLabels {
  Afternoon = 'Tarde',
  Evening = 'Noite',
  Flex = 'Flexível',
  FullTime = 'Integral',
  Morning = 'Manhã',
  UponRequest = 'Sob consulta',
}

export enum PeriodTypes {
  Afternoon = 'afternoon',
  Evening = 'evening',
  Flex = 'flex',
  FullTime = 'full_time',
  Morning = 'morning',
  UponRequest = 'upon_request',
}

export interface Installment {
  fee: number;
  min: number;
  max: number;
}

interface PricingDescription {
  type: PriceTypes;
  original_price: number | null;
  discount_percentage: number | null;
  sale_price: number | null;
  payment_conditions: {
    installments?: Installment[];
  };
}

interface RegressiveDiscount {
  month: number;
  discount: number;
  sale_price: number;
}

export interface Offer {
  offers_quantity: number;
  hash_key?: string;
  id: number;
  period: {
    type: PeriodTypes;
    label: string;
  };
  duration: {
    type: DurationTypes;
    quantity: number;
  };
  regressive_discount?: RegressiveDiscount;
  checkout_config?: CheckoutConfig;
  is_full_included: boolean;
  sale_type: PriceTypes;
  sale_price: number;
  discount_percentage: number;
  original_price: number;
  pricing_description: PricingDescription;
}

export interface CheapestOffer {
  id: number;
  checkout_config: CheckoutConfig;
  duration: Duration;
  period: Period;
  hash_key: string;
  is_full_included: boolean;
  pricing_description: PricingDescription;
  regressive_discount: RegressiveDiscount;
  hub_state: string;
  hub_city: string;
  hub_id: number;
  hub_name: string;
}

export interface ProductOfferSearch {
  filters: {
    cities: string[];
    hubs: Hub[];
    periods: Period[];
    states: State[];
  };
  offers_quantity: number;
  cheapest_offer: CheapestOffer;
}
